// Layout.tsx

import React from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../Header';
import Footer from '../Footer';
import { Box } from '@mui/material';
//import assets from '../../assets/assets.json';
import backImage from '../../assets/images/Logo/arrow-back-up.svg?url';
import Texts from '../Texts';

// The auth screens own their whole viewport: the promotional banner runs to
// the top and bottom edges, so the shared header and footer are rendered by
// the page itself (beside the banner) rather than across the window.
const FULL_BLEED_ROUTES = ['/register'];

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  const isFullBleed = FULL_BLEED_ROUTES.includes(location.pathname);

  // Define default values
  let buttonText = Texts.header.returnSibche;
  let iconSrc = backImage;

  // Customize based on the current route
  if (location.pathname === '/intro' || location.pathname === '/identify') {
    buttonText = Texts.header.exitAcount;
    iconSrc = backImage;
  }

  if (isFullBleed) {
    return (
      <Box
        component="main"
        sx={{ flex: 1, display: 'flex', flexDirection: 'column', width: '100%' }}
      >
        {children}
      </Box>
    );
  }

  return (
    <>
      <Header buttonText={buttonText} iconSrc={iconSrc} />
      <Box
        component="main"
        sx={{
          // #root is a flex column, so growing to fill the leftover space keeps
          // the footer at the bottom without hardcoding header/footer heights.
          flex: 1,
          // Column layout so a page can use height:100% to fill <main>.
          display: 'flex',
          flexDirection: 'column',
          padding: 2,
          width: '100%',
          boxSizing: 'border-box',
        }}
      >
        {children}
      </Box>
      <Footer />
    </>
  );
};

export default Layout;
